"use client";

import { useLocale, useTranslations } from "next-intl";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useSettings } from "@/src/components/providers/SettingsProvider";

type RegisterNowButtonProps = {
  className?: string;
  wide?: boolean;
  leftArrow?: boolean;
  fill?: "white" | "primary" | "transparent";
};

const RegisterNowButton = ({
  className = "",
  wide = false,
  leftArrow = false,
  fill = "primary",
}: RegisterNowButtonProps) => {
  const locale = useLocale();
  const t = useTranslations("Buttons");
  const { whatsapp } = useSettings();

  const isTransparent = fill === "transparent";

  const baseClasses =
    "rounded-lg py-3 flex items-center gap-2 font-medium overflow-hidden relative transition-colors duration-200 select-none";

  const layoutClasses = `${wide ? "min-w-40" : ""} ${
    isTransparent ? "justify-start" : "justify-center px-5"
  }`;

  const stateClasses = isTransparent
    ? "bg-transparent text-primary cursor-pointer hover:underline"
    : fill === "white"
      ? "button-white text-primary cursor-pointer"
      : "button-primary text-white cursor-pointer";

  if (!whatsapp) return null;

  return (
    <a
      href={whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className={`${baseClasses} ${layoutClasses} ${stateClasses} ${className} text-center`}
    >
      {t("registerNow")}
      {leftArrow ? (
        locale === "en" ? (
          <ArrowRight className="button-arrow-l w-4 h-5 text-current" />
        ) : (
          <ArrowLeft className="button-arrow-r w-4 h-5 text-current" />
        )
      ) : null}
    </a>
  );
};

export default RegisterNowButton;
